module.exports = __webpack_public_path__ + "img/coverage-professor.334d381b.svg";